module.exports = __webpack_public_path__ + "static/media/relixjpg1.736d232b.svg";